import React from 'react';
import { useLottie } from 'lottie-react';
import Loader from 'assets/animation/Loader.json';
import styles from './LoaderAnimation.module.scss';
const LoaderAnimation = () => {
  const options = {
    animationData: Loader,
    loop: true,
  };

  const { View } = useLottie(options);

  return <div test-id="loaderAnimation" className={styles.animationContainer}>{View}</div>;
};

export default LoaderAnimation;
